import { get } from "lodash";
import { RunnerBI } from "../../../hooks/useGetRunnerFromBI";
import {
  HandicappingTabValue,
  HandicappingTab,
  HandicappingTabsMap
} from "../../../types";

export const getRaceComments = (
  runners: RunnerBI[],
  activeDatasource: HandicappingTabValue
) =>
  runners
    .filter((item) => get(item, `${activeDatasource}.freePick.info`, null))
    .map((runner) => get(runner, `${activeDatasource}.freePick`, null));

export const getSortedRunners = (
  runners: RunnerBI[],
  activeDatasource: string
) =>
  runners.sort((a, b) => {
    const numberA = get(a, `${activeDatasource}.freePick.number`, a.biNumber);
    const numberB = get(b, `${activeDatasource}.freePick.number`, b.biNumber);

    return numberA > numberB ? 1 : -1;
  });

/**
 * Returns an array of all the tabs that will have comments to display
 * @param tabs
 * @param trackDatasource
 * @param defaultTabs
 * @param runners
 * @returns
 */
export const getFilteredTabs = (
  tabs: HandicappingTabsMap,
  trackDatasource: string,
  defaultTabs: HandicappingTab[],
  runners: RunnerBI[],
  raceComment: string
): HandicappingTab[] =>
  get(tabs, trackDatasource, defaultTabs).filter(
    ({ value }: HandicappingTab) =>
      raceComment?.length > 0 || getRaceComments(runners, value).length > 0
  );
